import React from 'react';
import Button from '../ui/Button';
import { toast } from 'react-hot-toast';

interface AffiliateLinkModalProps {
  isOpen: boolean;
  onClose: () => void;
  affiliateLink: string;
}

const AffiliateLinkModal: React.FC<AffiliateLinkModalProps> = ({ isOpen, onClose, affiliateLink }) => {
  if (!isOpen) return null;

  const handleCopyLink = () => {
    navigator.clipboard.writeText(affiliateLink);
    toast.success('Affiliate link copied to clipboard!');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-75 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-md transform transition-all sm:p-8">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-primary">Your Affiliate Link</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            aria-label="Close modal"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        
        <p className="text-gray-700 mb-4">Share this link with potential affiliates:</p>
        
        <div className="relative mb-6">
          <input
            type="text"
            readOnly
            value={affiliateLink}
            className="w-full p-3 pr-12 border border-gray-300 rounded-md bg-gray-50 text-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
          />
          <button
            onClick={handleCopyLink}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-primary transition-colors"
            aria-label="Copy link to clipboard"
          >
            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
            </svg>
          </button>
        </div>
        
        <div className="flex justify-end space-x-3">
          <Button variant="outline" onClick={onClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleCopyLink}>
            Copy Link
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AffiliateLinkModal;